import { render } from "./Sidebar.vue?vue&type=template&id=deaffcf2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=deaffcf2&lang=scss&scoped=true"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deaffcf2"]])

export default __exports__